import { useState, useEffect } from 'react';
import { booksApi, genresApi, Genre, BookLibrarianStats } from '@/services/catalog-api';

interface CatalogMetaState {
  stats: BookLibrarianStats | null;
  genres: Genre[];
  isLoading: boolean;
  error: string | null;
}

export function useCatalogMeta(): CatalogMetaState {
  const [state, setState] = useState<CatalogMetaState>({
    stats: null,
    genres: [],
    isLoading: true,
    error: null,
  });

  useEffect(() => {
    let cancelled = false;

    Promise.all([
      booksApi.getStatistics(),
      genresApi.getGenres({ page_size: 100 }),
    ])
      .then(([stats, genresResponse]) => {
        if (cancelled) return;
        setState({
          stats,
          genres: genresResponse.results,
          isLoading: false,
          error: null,
        });
      })
      .catch((err) => {
        if (cancelled) return;
        console.error('[useCatalogMeta] Failed to load catalog metadata:', err);
        setState((prev) => ({ ...prev, isLoading: false, error: 'Failed to load catalog metadata' }));
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
